export const apiUri = process.env.VUE_APP_API_BASE_URL || `http://localhost:3000`;
export const wsUri = process.env.VUE_APP_WS_BASE_URL;
export const otaUri = process.env.VUE_APP_OTA_API_BASE_URL || `http://localhost:3000`;
export const iotsafeUri = process.env.VUE_APP_IOT_SAFE_API_BASE_URL || `http://localhost:3002`;
export const eimUri = process.env.VUE_APP_EIM_API_BASE_URL || `http://localhost:3003`;
